import type { ClassAttributes, ComponentType, HTMLAttributes, ReactNode } from 'react';
import { styled, type StyledProps } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import type { FieldWidth } from '@atlassian/jira-issue-create-common-types/src/common/types/index.tsx';
import { isMobileAndInMvpOrExistingUsersExperiment } from '@atlassian/jira-mobile-web/src/index.tsx';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const FieldContainer: ComponentType<
	{
		children?: ReactNode;
		width?: FieldWidth;
		marginTop?: number;
		paddingBottom?: number;
	} & ClassAttributes<HTMLDivElement> &
		HTMLAttributes<HTMLDivElement> &
		StyledProps
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
> = styled.div<{
	children?: ReactNode;
	width?: FieldWidth;
	marginTop?: number;
	paddingBottom?: number;
}>({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	width: ({ width = isMobileAndInMvpOrExistingUsersExperiment() ? '100%' : 350 }) => {
		return typeof width === 'number' ? `${width}px` : width;
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	marginTop: ({ marginTop = 0 }) => `${marginTop}px`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	paddingBottom: ({ paddingBottom = 0 }) => `${paddingBottom}px`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Description: ComponentType<
	{
		children?: ReactNode;
	} & ClassAttributes<HTMLParagraphElement> &
		HTMLAttributes<HTMLParagraphElement> &
		StyledProps
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
> = styled.p<{
	children?: ReactNode;
}>({
	marginBottom: token('space.100'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const SelectContainer: ComponentType<
	{
		children?: ReactNode;
	} & ClassAttributes<HTMLDivElement> &
		HTMLAttributes<HTMLDivElement> &
		StyledProps
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
> = styled.div<{
	children?: ReactNode;
}>({
	width: '300px',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Divider: ComponentType<
	{
		children?: ReactNode;
	} & ClassAttributes<HTMLDivElement> &
		HTMLAttributes<HTMLDivElement> &
		StyledProps
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
> = styled.div<{
	children?: ReactNode;
}>({
	height: '1px',
	width: '100%',

	backgroundColor: token('color.border'),
	marginTop: token('space.300'),
	marginRight: 0,
	marginBottom: token('space.300'),
	marginLeft: 0,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const CloseButtonContainer: ComponentType<
	{
		children?: ReactNode;
	} & ClassAttributes<HTMLDivElement> &
		HTMLAttributes<HTMLDivElement> &
		StyledProps
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
> = styled.div<{
	children?: ReactNode;
}>({
	marginLeft: 'auto',
	marginRight: token('space.100'),
});
